import { NavLink } from "react-router-dom";
import styled from "styled-components";

import { Button } from "./Button";

const LinkButton = Button.withComponent(NavLink);

export const ActiveLinkButton = styled(LinkButton)`
    background: #fff !important;
    color: #f78f21 !important;
    box-shadow: inset 0 0 0 1px #f78f21;
    margin: 5px 10px 5px 0;

    &.active {
        background: #f78f21 !important;
        color: #fff !important;
    }
`;
